import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Checkbox } from "@material-ui/core";
import {
  getAllActionsListRequest,
  getSelectionListRequest,
  updateSelectionRequest,
  checkAction
} from "../../services/action/actions";
import Colors from "../../constants/Colors";
import Tab from "./Tab";
import Selection from "./Selection";
import MyActionsSelected from "./MyActionsSelected";
import MyActionsCreated from "./MyActionsCreated";
import Snackbar from "./Snackbar";
import Creation from "./Creation";

const styles = theme => ({
  main: {
    flex: 1,
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // paddingTop: 20,
    paddingBottom: 100
  },
  inputForm: {
    marginTop: 15,
    marginBottom: 15,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start"
  },
  inputLabel: {
    marginRight: 10,
    marginLeft: 10
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    textOverflow: "ellipsis",
    overflow: "hidden",
    // whiteSpace: "nowrap",
    color: Colors.text,
    width: "90%"
  },
  title: {
    fontSize: theme.typography.pxToRem(15),
    marginBottom: 15,
    color: Colors.text
  },
  separator: {
    fontSize: theme.typography.pxToRem(15),
    marginBottom: 10,
    fontWeight: "bold",
    color: Colors.text
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  table: {
    minWidth: 700
  },
  root: {
    width: "90%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    marginBottom: 15
  },
  button: {
    marginLeft: 15
  },
  actionRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  },
  rowSelected: {
    backgroundColor: Colors.lightGrey
  },
  expansionDiv: {
    flex: 1
  },
  details: {
    flexDirection: "row",
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-start"
  },
  checkDiv: {
    height: "100%"
    // backgroundColor: "#fff"
  },
  mainTitle: {
    alignSelf: "left",
    fontWeight: 500,
    marginBottom: 15
  },
  saveButton: {
    backgroundColor: Colors.main
  }
});

class ActionsScreen extends PureComponent {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.main}>
        <Typography
          align="left"
          variant="h5"
          classes={{ root: classes.mainTitle }}
        >
          Sélection des actions
        </Typography>
        <Tab />
        {this.props.tabSelected === 0 && <Selection />}
        {this.props.tabSelected === 1 && <MyActionsSelected />}
        {this.props.tabSelected === 2 && <Creation />}
        {this.props.tabSelected === 3 && <MyActionsCreated />}
        <Snackbar />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { selectionList, allActions, requesting, tabSelected } = state.action;
  const { clientId } = state.client;
  return {
    token: state.auth.token,
    clientId,
    selectionList,
    allActions,
    requesting,
    tabSelected
  };
};

export default connect(
  mapStateToProps,
  {
    getAllActionsListRequest,
    getSelectionListRequest,
    updateSelectionRequest,
    checkAction
  }
)(withStyles(styles)(ActionsScreen));
